import React from "react";
import { ShieldCheck, Send } from "lucide-react";
import { TeamBadge } from "@/components/TeamBadge";

// Customers only learn who a collector is once that collector has contacted them.
export const CustomerLeadTitle = ({ l, large = false }) => {
  const cls = `font-heading ${large ? "text-lg" : "text-base"} text-[#1E3F33] inline-flex items-center gap-2`;
  if (!l.collector_revealed) {
    return (
      <div data-testid={`lead-collector-hidden-${l.id}`}>
        <div className={cls}><Send className="w-4 h-4 text-[#8A9A86]"/> Sent to a collector near you</div>
        {l.status === "requested" && <div className="text-xs text-[#8A9A86] mt-0.5">Waiting for contact</div>}
      </div>
    );
  }
  return (
    <div data-testid={`lead-collector-name-${l.id}`}>
      <div className={cls}><ShieldCheck className="w-4 h-4 text-[#2D6A4F]"/> {l.collector_business_name || "Collector"}</div>
      {l.status === "contacted" && l.company_name && <div><TeamBadge name={l.company_name} logo={l.company_logo_url} testid={`lead-team-badge-${l.id}`} /></div>}
    </div>
  );
};
